module.exports = __webpack_public_path__ + "img/OBJECTIVER00.b08da8c7.png";